module.exports = JSON.parse('{"languageSwitcher":{"label":"Язык"},"close":"Закрыть","pageTitle":"Новый год 2027 — Ничего лишнего! | NL International"}')